<template>
  <el-row
    class="input-extent"
    :class="{errBorder: errBorder && warning}"
  >
    <el-input
      ref="minInput"
      class="minInput"
      :type="minInputType"
      :value="minVal"
      v-bind="{...attribute, ...minAttribute}"
      @change="minChange"
      @input="minInput"
    ></el-input>
    <div class="transition">{{transition}}</div>
    <el-input
      ref="maxInput"
      class="maxInput"
      :type="maxInputType"
      :value="maxVal"
      v-bind="{...attribute, ...maxAttribute}"
      @change="maxChange"
      @input="maxInput"
    ></el-input>
  </el-row>
</template>

<script>
// 必填校验（前后数据必填）
// 阈值校验（前值小于后值）
// 数值转换（转换为number类型）
// 数值类型校验（自定义数值类型）
// 重置校验（改变一个值，重置前后输入框校验）
export default {
  props: {
    value: {
      type: [String, Array]
    },
    minInputType: {
      type: [String, Number],
      default: 'text'
    },
    maxInputType: {
      type: [String, Number],
      default: 'text'
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    attribute: {
      type: Object
    },
    minAttribute: {
      type: Object
    },
    maxAttribute: {
      type: Object
    },
    transition: {
      type: String,
      default: '-'
    },
    verify: {
      type: Boolean,
      default: true
    },
    warning: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      minVal: '',
      maxVal: '',
      errBorder: false
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.minVal = val[0]
          this.maxVal = val[1]
        } else {
          this.minVal = ''
          this.maxVal = ''
        }
      }
    }
  },
  methods: {
    minChange() {
      this.formatter()
    },
    minInput(val) {
      this.minVal = val
    },
    maxChange() {
      this.formatter()
    },
    maxInput(val) {
      this.maxVal = val
    },
    formatter() {
      // 不执行数值校验
      if (!this.verify) {
        this.errBorder = false
        this.$emit('input', [this.minVal, this.maxVal])
        return false
      }
      // 数值类型判断
      if (!parseFloat(this.minVal)) {
        if (this.minVal) {
          this.errBorder = true // 有值警告
        } else {
          this.errBorder = false // 无值重置
        }
        this.minVal = ''
        return false
      }
      if (!parseFloat(this.maxVal)) {
        if (this.maxVal) {
          this.errBorder = true // 有值警告
        } else {
          this.errBorder = false // 无值重置
        }
        this.maxVal = ''
        return false
      }

      // 数值转换
      this.minVal = parseFloat(this.minVal)
      this.maxVal = parseFloat(this.maxVal)

      // 必填判断
      if (!(this.minVal && this.maxVal)) {
        this.errBorder = true
        return false
      }
      // 阈值判断
      if (this.min != undefined && this.minVal < this.min) {
        this.minVal = ''
        this.errBorder = true
        return false
      }

      if (this.max != undefined && this.maxVal > this.max) {
        this.maxVal = ''
        this.errBorder = true
        return false
      }

      if (this.minVal > this.maxVal) {
        this.minVal = ''
        this.errBorder = true
        return false
      }
      this.errBorder = false
      this.$emit('input', [this.minVal, this.maxVal])
    }
  },
  components: {}
}
</script>

<style lang="scss">
.input-extent {
  width: 376px;
  border: 1px solid #dfe3e9;
  border-radius: 4px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  .el-input__inner {
    border: none;
    text-align: center;
  }
}

.errBorder {
  border: 1px solid #fe6c6f;
}
</style>
